var a = /* @__PURE__ */ ((r) => (r.fixed = "fixed", r.interval = "interval", r.gradient = "gradient", r))(a || {}), d = /* @__PURE__ */ ((r) => (r.growth = "growth", r.period = "period", r.filters = "filters", r.display = "display", r))(d || {});
export {
  a as ColorTypes,
  d as MetricOptionsFormKeys
};
//# sourceMappingURL=MetricOptionForm.types.js.map
